<style scoped>

  .content {
    padding: 5px 20px 20px 20px !important;
  }

</style>

<template>
  
  <div>

    <div id="reserve-dialog" class="ui large modal reserve-modal">

      <div class="ui header">
        {{ $store.state.user.isProspect ? 'Manifestação de Interesse em Produto' : 'Confirmação de Reserva de Produto' }}
      </div>

      <div class="content modal-content-scrolling">

        <form v-if="balance" class="ui form m-t-10" @submit.prevent="onConfirm()">
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Unidade</label>
              <input type="text" readonly="readonly" :value="balance.branch.name">
            </div>
          </div>          
          <div v-if="!$isCustomerOrProspect()" class="fields">
            <div class="four wide field">
              <label class="form-label">Código <span class="red text">*</span></label>
              <input v-if="successMessage" type="text" :value="customerCode" readonly="readonly">
              <div v-else class="ui action input">
                <input type="text" maxlength="6" v-model="customerCode" :readonly="lChgCus" @blur="onBlurCustomerCode()">
                <button type="button" :class="[lChgCus ? 'ui disabled button' : 'ui basic icon button']"  @click="$refs.customerPicker.show()">
                  <i class="search plus black icon"></i>
                </button>
              </div>
            </div>
            <div class="two wide field">
              <label class="form-label">Loja <span class="red text">*</span></label>
              <input v-if="successMessage" type="text" :value="customerUnit" readonly="readonly">
              <input v-else type="text" maxlength="2" v-model="customerUnit" :readonly="lChgCus" @blur="onBlurCustomerUnit()">
            </div>
            <div class="ten wide field">
              <label class="form-label">Razão Social</label>
              <input type="text" readonly="readonly" :value="customerName">
            </div>
          </div> 
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Produto</label>
              <input type="text" readonly="readonly" :value="balance.product.description">
            </div>
          </div>
          <div class="fields">
            <div class="ten wide field">
              <label class="form-label">Acondicionamento</label>
              <input type="text" readonly="readonly" :value="balance.address">
            </div>
            <div class="six wide field">
              <label class="form-label">Cor</label>
              <input type="text" readonly="readonly" :value="balance.product.color">
            </div>
          </div>
          <div class="fields">
            <div class="four wide field">
              <label class="form-label">Total Disponível</label>
              <input type="text" readonly="readonly" :value="$formatInteger(balance.total)">
            </div>  
            <div class="four wide field">
              <label class="form-label">
                {{ $store.state.user.isProspect ? 'Quant. desejada' : 'Quant. Reservada' }}
                <span class="red text">*</span>
              </label>
              <input v-show="successMessage" type="text" readonly="readonly" :value="$formatInteger(quantity)">
              <input v-show="!successMessage" class="integer" :value="inputQuantity" @blur="inputQuantity = $event.target.value">
            </div>
            <div class="four wide field">
              <label class="form-label">
                {{ $store.state.user.isProspect ? 'Total desejado' : 'Total Reservado' }}
              </label>
              <input type="text" readonly="readonly" :value="$formatInteger(total)">
            </div>
          </div>
        </form>              

        <div v-if="successMessage" class="ui message m-t-20 animated fadeIn">
          <strong class="m-r-5"><i class="check circle blue icon"></i> {{ successMessage.title }}</strong>
          {{ successMessage.text }} <strong v-if="successMessage.reserveId">{{ successMessage.reserveId }}</strong>
        </div>  

        <div v-else style="height: 50px;"></div>

      </div>

      <div class="actions">
        <button class="ui cancel basic button">
          <i class="reply icon"></i>
          Sair
        </button>
        <button v-if="!successMessage" type="button" class="ui blue button" :class="{ loading }" @click="onConfirm()">
          <i class="check icon"></i>
          Confirmar
        </button>
      </div>

    </div>

    <customer-picker ref="customerPicker" id="reserve-customer-picker" 
      :allowMultiple="true" @onSelect="onSelectCustomer"/>

  </div> 

</template>

<script>
  
  import CustomerPicker from "@/components/customer-picker.vue"
  import { CustomerService, OppBalanceService } from "@/services"
  import { Input, Message } from "@/utils"

  let inputsCreated = false

  export default {

    data() {
      return {
        loading: false,
        customerCode: "",
        customerUnit: "",
        customerName: "",
        quantity: 0,
        total: 0,
        reserveId: 0,
        successMessage: null,
      }
    },

    props: ["balance", "customer", "lChgCus"],

    computed: {

      inputQuantity: {
        get() {
          return Input.integerToString(this.quantity)
        },
        set(value) {

          if (!value)
            value = 0

          const unit = (this.balance.total / this.balance.quantity)

          this.quantity = Input.stringToInteger(value)
          this.total = (this.quantity * unit)          
        },
      },
    },

    watch: {
      
      "customer" () {

        if (this.customer) {
          this.customerCode = this.customer.code
          this.customerUnit = this.customer.unit
          this.customerName = this.customer.name
        } else {
          this.customerCode = ""
          this.customerUnit = ""
          this.customerName = ""
        }
      },
    },

    components: {
      CustomerPicker,
    },    

    mounted() {

      $("#reserve-dialog").modal({
        autofocus: false,
        onVisible: () => {

          if (inputsCreated)
            return      

          Input.maskInteger()

          inputsCreated = true
        }
      })
    },

    beforeDestroy() {
      $(".reserve-modal").remove()
    },

    methods: {

      show() {

        this.successMessage = null
        this.quantity = 0
        this.total = 0

        $("#reserve-dialog").modal("show")
      },

      hide() {
        $("#reserve-dialog").modal("hide")
      },

      onBlurCustomerCode() {

        if (!this.customerCode) {
          this.customerUnit = ""
          this.customerName = ""
          return
        }  

        if (!this.customerUnit)
          this.customerUnit = "01"

        this.loadCustomer()
      },

      onBlurCustomerUnit() {

        if (this.customerCode && this.customerUnit)
          this.loadCustomer()
      },

      async loadCustomer() {

        this.loading = true

        try {

          const customer = await CustomerService.getByCode(this.customerCode, this.customerUnit)

          if (customer.isBlocked) {
            Message.info("Cliente bloqueado")
          } else {
            this.customerName = customer.name
          }

          this.loading = false          

        } catch (error) {

          this.loading = false
          this.customerName = ""

          this.$errorHandler(error)
        }
      },

      onSelectCustomer(customer) {

        this.customerCode = customer.code
        this.customerUnit = customer.unit
        this.customerName = customer.name
      },

      async onConfirm() {

        if (this.loading)
          return

        if (!this.validData())
          return
        
        this.loading = true

        try {

          let data = {
            branch: this.balance.branch.id,
            productCode: this.balance.product.code,
            customerCode: this.customerCode,
            customerUnit: this.customerUnit,
            address: this.balance.address,
            idAddress: this.balance.idAddress,
            quantity: this.quantity,
            total: this.total,
          }

          if (this.$store.state.user.isProspect) {

            await OppBalanceService.interest(data)

            this.successMessage = {
              title: "Recebemos sua manifestação de interesse!",
              text: "Em breve entraremos em contato.",
            }

          } else {

            const reserveId = await OppBalanceService.reserve(data)
            this.reserveId = reserveId

            this.successMessage = {
              title: "Recebemos sua reserva!",
              text: "Número da reserva para acompanhamento: ",
              reserveId,
            }
          }

          this.loading = false

          this.$emit("onConfirm", data, this.reserveId)
          this.hide()
          
        } catch (error) {
          
          this.loading = false
          this.$errorHandler(error)
        }

      },
      
      validData() {

        let isOk = true
        let message = ""

        if (this.$isCustomerOrProspect()) {
          this.customerCode = this.$store.state.user.customer.code
          this.customerUnit = this.$store.state.user.customer.unit
          this.customerName = this.$store.state.user.customer.name
        }

        if (!this.customerName) {
          message = "Informe o cliente"
        } else if (this.quantity == 0) {
          message = "Informe a quantidade"
        } else if (this.total > this.balance.total) {
          message = "Quantidade indisponível"
        }

        if (message) {
          isOk = false
          Message.info(message)
        }

        return isOk
      },
    },
  }

</script>
